define([], function () {
    var framework = {
        "title.error": "Error",
        "title.prompt": "Information",
        "title.confirm": "Confirm",
        "title.warn": "Warning",
        
        "hasBindUniportal": "Your HUAWEI CLOUD account has already been upgraded. Use your HUAWEI ID to log in.",

        "mobileLoginModel.intlIpTip": "Esta página somente pode ser usada para acessar com um número de celular da parte continental da China.",
        "mobileLoginModel.mobileLogin": "Acesso por número de celular",
        "mobileLoginModel.accountLogin": "Acesso por conta/e-mail",
        "mobileLoginModel.mobilePlaceHolder": "Número de celular",
        "mobileLoginModel.accountPlaceHolder": "Nome da conta ou e-mail",
        "mobileLoginModel.userPlaceHolder": "Nome de usuário do IAM ou e-mail",
        "mobileLoginModel.notRegisterTip": "Número de celular não registrado.",
        "mobileLoginModel.isMobileTip": "",
        "mobileLoginModel.registerNow": "Registrar agora",
        "mobileLoginModel.multiUsersTip": "O número de celular está vinculado a várias contas. Selecione a conta que você deseja usar.",
        "mobileLoginModel.operationTooFrequent": "As operações foram feitas frequentemente demais. Tente novamente após {0} minutos.",
        "mobileLoginModel.invalidNumber": "Informe um número de telefone válido.",
        "mobileLoginModel.retry": "Tentar novamente",
        "mobileLoginModel.retrievePwd": "Recuperar senha",
        "emailLoginModel.multiUsersTip": "The email address is bound to multiple accounts. Select the account you want to use.",   //TODO
        "fpwd.multiEmailUsersTip": "The email address is bound to multiple accounts. Select the account for which you want to reset the password.", //TODO

        "loginRegistTip": "Novos usuários precisam ter um convite para fazer o registro.",
        "accountName": " Nome da conta",
        "uniportalTip": "Contas do site da Huawei, parceiros da Huawei, funcionários da Huawei e desenvolvedores de TIC",
        "activeAccount": "Ativar",
        "activeAccountMsg": "Caro usuário da Huawei, este é seu primeiro acesso no HUAWEI CLOUD. Você precisa ler e concordar com o Contrato do Cliente e a Declaração de Privacidade do HUAWEI CLOUD antes de ativar o serviço.",
        "userNameTip": "Nome de usuário:",
        "searchBoxPlaceHolder": "Informe uma palavra-chave.",
        "submitBtnTxt": "OK",
        "cancelBtnTxt": "Cancelar",
        "btnTxtOK": "OK",
        "btnTxtCancel": "Cancelar",
        "btnTxtYes": "Sim",
        "btnTxtNo": "Não",
        "logout": "Sair",
        "connect": "e",
        "emptyStr": "--",
        "blankTxt": "Este campo não pode ficar em branco.",
        "emptyTxt": "Este campo não pode ficar em branco. Não são permitidos espaços.",
        "nameBlankTxt": "Este campo não pode ficar em branco.",
        "passwordEqual": "As senhas não correspondem.",
        "validEmail": "Informe um endereço e-mail válido.",
        "validPhone": "Informe um número de celular válido.",
        "maxLenTxt": "Digite no máximo {0} caracteres.",
        "minLenTxt": "Informe pelo menos {0} caracteres.",
        "minMaxLenTxt": "Precisa ter de {0} a {1} caracteres.",
        "phoneMaxLenTxt": "Digite no máximo {0} dígitos.",
        "msgCodeErrorInfo": "Apenas dígitos são permitidos.",
        "nameContainsChar": "Use somente letras, dígitos, hifens (-) ou traços-baixos (_) e comece com uma letra ou hífen (-).",
        "commonContainsChar": "Apenas letras e dígitos são permitidos.",
        "pwdNotUsernameOrInvert": "Não pode ser o nome de usuário ou o nome de usuário de trás para a frente.",
        "pwdNotContsMobileOrEmail": "A senha não pode conter o número de celular nem o endereço e-mail.",
        "pwdNotContsMobile": "Não inclua seu número de celular completo.",
        "pwdcantContsMobileOrEmail": "A senha não pode conter o número de celular nem o endereço e-mail.",
        "pwdWeak": "The password could be leaked. Enter another one. ",
        "usernameNotPwdOrInvert": "O nome de usuário não pode ser a senha ou a senha escrita de trás para frente.",
        "passwordChars": "Deve conter pelo menos {0} dos seguintes tipos de caracteres: letras maiúsculas, letras minúsculas, dígitos e caracteres especiais (~`! ?,.:; -_'\" ( ) { } [ ] /<>@# $% ^& * + |\\ = e espaços).",
        "mobilePasswordChars1": "A senha precisa ter pelo menos dois dos seguintes tipos de caractere: ",
        "mobilePasswordChars2": "letras maiúsculas, letras minúsculas, dígitos e caracteres especiais.",
        "validEmailOrPhone": "Informe um endereço de e-mail válido ou um número de celular.",
        "validAccountName": "Informe um nome de conta válido.",
        "validPwd": "Informe uma senha válida.",
        "validAgency": "Informe um nome de agente válido.",
        "validCheckCode": "Informe no máximo 4 caracteres.",
        "tooMuchErrorCode": "Você inseriu códigos de verificação incorretos várias vezes. Obtenha outro código de verificação.",
        "pwdCannotEqualName": "Não pode ser o nome da conta ou o nome da conta escrito de trás para frente.",
        "passwordPolicy.errorMsgOfRptChar": "A senha pode ter no máximo {0} caracteres iguais consecutivos.",
        "inValidCcompanyName": "Não pode ter apenas caracteres especiais, dígitos, espaços ou caracteres de tabulação.",
        "companyNameLength": "Informe no máximo 32 caracteres.",
        "accountTipInfo": "Informações da conta:",
        "yes": "Sim",
        "no": "Não",
        "iamUserTip": "Caso tenha sido criado por uma conta do HUAWEI CLOUD, acesse como um usuário do IAM.",
        "registerFailed": "Falha no registro.",
        "recommended": "Recomendado",
        "strengthLow": "Fraco",
        "strengthMid": "Médio",
        "strengthHigh": "Forte",
        "accountNameBlank": "O nome da conta não pode ficar em branco.",
        "userNameBlank": "O nome de usuário não pode ficar em branco.",
        "pwdBlank": "A senha não pode ficar em branco.",
        "checkCodeBlank": "O código de verificação não pode ficar em branco.",
        "phoneBlank": "O número de celular não pode ficar em branco.",
        "checkCodeBlank4Intl": "Informe um código de verificação.",
        "backToHomepage": "Voltar a Página inicial",
        "backTo": "Voltar",
        "homepage": "Início",
        "mobileHome": "Página inicial",
        "isHwsUser": "Você está acessando o site internacional do HUAWEI CLOUD. Clique aqui para acessar o site chinês do HUAWEI CLOUD.",
        "isHongKongUser": "Você está acessando o site chinês do HUAWEI CLOUD. Clique aqui para acessar o site internacional do HUAWEI CLOUD.",
        "isRuUser": "Você está acessando o site internacional do HUAWEI CLOUD. Clique aqui para acessar o site internacional do HUAWEI CLOUD.",
        "isHwsUser1": "Você está acessando o site internacional do HUAWEI CLOUD. Clique ",
        "isHongKongUser1": "Você está acessando o site chinês do HUAWEI CLOUD. Clique ",
        "isRuUser1": "Você está acessando o site internacional do HUAWEI CLOUD. Clique ",
        "goLogin.hws": "aqui",
        "goLogin.hk": "aqui",
        "goLogin.ru": "aqui",
        "toLogin.hws": " para acessar o site chinês do HUAWEI CLOUD.",
        "toLogin.hk": " para acessar o site internacional do HUAWEI CLOUD.",
        "toLogin.ru": " para acessar o site internacional do HUAWEI CLOUD.",
        "language": "Inglês",
        "lanuage.hk": "Internacional",
        "lanuage.ch":"中国站",
        "lanuage.zh-cn":"简体中文",
        "lanuage.en-us": "Inglês",
        "titles.login": "Acesso ao HUAWEI CLOUD",
        "titles.resetPwd": "Redefinir senha do HUAWEI CLOUD",
        "titles.fpwd": "Senha esquecida do HUAWEI CLOUD",
        "titles.register": "Registro no HUAWEI CLOUD",
        "titles.agencyRegister": "Registro de agente no HUAWEI CLOUD",
        "titles.reactivate": "Reativação do HUAWEI CLOUD",
        "titles.registerSuccess": "Registro bem-sucedido no HUAWEI CLOUD",
        "titles.fphone": "Alteração de número de celular no HUAWEI CLOUD",
        "titles.loginVerification": "Verificação de acesso no HUAWEI CLOUD",
        "titles.bindAccount": "Primeiro acesso no HUAWEI CLOUD",
        "titles.bindAccountSuccess": "Registro bem-sucedido no (registro e vinculação) HUAWEI CLOUD",
        "registerFree": "Registre sua conta do HUAWEI CLOUD",
        "freeRegister": "Registro gratuito",
        "createDomain": "Criar conta",
        "createDomainBtn": "Criar e vincular",
        "createSubUser": "Criar conta de subusuário",
        "createFailed": "Falha ao criar a conta.",
        "bindDomain": "Vincular conta",
        "createDomainLink": "Criar conta",
        "bindDomainLink": "Vincular conta",
        "bindFailed": "Falha ao vincular a conta.",
        "bindRepeat": "Sua conta foi vinculada a outro parceiro. Não a vincule novamente.",
        "createDomain.remindCompleteInfo": "Informe os dados a seguir para criar e vincular uma conta do HUAWEI CLOUD. Já tem uma conta?",
        "bindDomain.remindCompleteInfo": "Informe os dados a seguir para criar e vincular uma conta do HUAWEI CLOUD. Ainda não tem uma conta?",
        "createSubUserInfo": "Informe os dados a seguir para criar e vincular uma conta de subusuário do HUAWEI CLOUD.",
        "enterpriseUser": "Acesso de usuário do IAM",
        "enterpriseUserLogin": "Acesso de usuário do IAM",
        "personageUser": "Acesso de conta",
        "enterpriseUser4Intl": "Acesso de usuário do IAM (Internacional)",
        "personageUser4Intl": "Acesso de conta (Internacional)",
        "accountPlaceHolder": "Nome da conta",
        "HongKongAccountPlaceHolder": "Nome da conta",
        "domainPlaceHolder": "ID/nome do agente",
        "roleNamePlaceHolder": "Nome do agente",
        "failedToswitchRole": "Falha na troca de agente.",
        "switchSubmit": "Mudar de função",
        "agencyDesc": "A senha e a ID do usuário podem ser utilizadas para gerenciar recursos de várias contas. Depois que um administrador do HUAWEI CLOUD configurar os papéis para você e fornecer os dados da conta e do papel, você poderá trocar de papel.",
        "userNamePlaceHolder": "Nome de usuário do IAM, e-mail, número de celular",
        "HongKongUserNamePlaceHolder": "Nome de usuário do IAM ou e-mail",
        "accountNamePlaceHolder": "Nome da conta, e-mail ou número de celular",
        "HongKongAccountNamePlaceHolder": "Nome da conta ou e-mail",
        "accountTip": "Conta",
        "passwdPlaceHolder": "Senha",
        "iamPasswdPlaceHolder": "IAM user password",//TODO: 翻译
        "verifyCodePlaceHolder": "Código CAPTCHA",
        "GraphicsVerifyCodeLabel": "Código de verificação:,    ",
        "GraphicsVerifyCode": "Verificação de segurança",
        "InputGrapVerifyCodeInfo": "Para garantir a segurança da conta, informe o código que aparece na imagem a seguir.",
        "GrapVerifyCodeFailed": "O código de verificação está incorreto ou expirou. Tente novamente.",
        "getVerifyCode": "Obtenha outro código de verificação.",
        "loginSubmit": "Acesso",
        "logining": "Acessando...",
        "mobileNumberLogin": "Número de celular",
        "noMobileLogin": "Nome da conta ou e-mail",
        "userNameMobliePH": "Número de celular",
        "rememberName": " Lembrar de mim",
        "rememberLogin": " Lembrar de mim",
        "rememberName4Intl": " Lembrar de mim",
        "forgetPwd": "Esqueceu a senha?",
        "emaiNamePwd": "Endereço de e-mail incorreto.",
        "phoneNamePwd": "Número de celular incorreto.",
        "domainNamePwd": "Nome de usuário incorreto.",
        "wrongNamePwd": "Senha incorreta.",
        "wrongNamePwd4Intl": "Nome de usuário ou endereço e-mail incorreto.",
        //TODO: 翻译
        "learnMore": "Learn more",
        "iamAccountTip": "The account used to create an IAM user in IAM. ",
        "iamUsernameTip": "An IAM user created using the account in IAM. ",
        "iamAccountTipHelp": "/en-us/productdesc-iam/iam_01_0023.html?utm_campaign=ua&utm_content=iam&utm_term=login#section0",
        "iamUsernameTipHelp": "/en-us/productdesc-iam/iam_01_0023.html?utm_campaign=ua&utm_content=iam&utm_term=login#section1",

        "wrongIPBlacklist": "O dispositivo usado para acessar não é seguro. Use outro dispositivo.",
        "wrongIPFrequencyLimiting": "O número de tentativas de acesso incorretas provenientes do mesmo endereço IP atingiu o limite máximo. Tente novamente mais tarde.",
        "wrongEquipmentIDFrequencyLimiting": "O número de tentativas de acesso incorretas provenientes do mesmo dispositivo atingiu o limite máximo. Tente novamente mais tarde ou use outro dispositivo para acessar.",
        "MachineOperation": "O dispositivo usado para acessar não é seguro. Use outro dispositivo.",
        "emaiNamePwdChances": "Endereço de e-mail incorreto. Você precisará acessar novamente após mais {0} tentativas incorretas.",
        "phoneNamePwdChances": "Número de celular incorreto. Você precisará acessar novamente após mais {0} tentativas incorretas.",
        "domainNamePwdChances": "Nome de usuário incorreto. Você precisará acessar novamente após mais {0} tentativas incorretas.",
        "wrongNamePwdChances": "Senha incorreta. Você precisará acessar novamente após mais {0} tentativas incorretas.",
        "wrongNamePwdFourChances": "Informações de autenticação incorretas. Depois de mais 4 tentativas incorretas, o acesso será desabilitado por 15 minutos.",
        "wrongNamePwdThreeChances": "Informações de autenticação incorretas. Depois de mais 3 tentativas incorretas, o acesso será desabilitado por 15 minutos.",
        "wrongNamePwdTwoChances": "Informações de autenticação incorretas. Depois de mais 2 tentativas incorretas, o acesso será desabilitado por 15 minutos.",
        "wrongNamePwdoneChances": "Informações de autenticação incorretas. Depois de mais 1 tentativa incorreta, o acesso será desabilitado por 15 minutos.",
        "wrongNamePwdFourChances4Intl": "Senha incorreta. Você tem mais 4 tentativas antes do bloqueio de 15 minutos.",
        "wrongNamePwdThreeChances4Intl": "Senha incorreta. Você tem mais 3 tentativas antes do bloqueio de 15 minutos.",
        "wrongNamePwdTwoChances4Intl": "Senha incorreta. Você tem mais 2 tentativas antes do bloqueio de 15 minutos.",
        "wrongNamePwdoneChances4Intl": "Senha incorreta. Você tem mais 1 tentativa antes do bloqueio de 15 minutos.",
        "userAccountsLocked": "Você informou a senha ou o nome de usuário incorreto 5 vezes. O nome de usuário será bloqueado por 15 minutos.",
        "userAccountsStopped": "O usuário foi desativado. Entre em contato com o administrador.",
        "domainAccountsStopped": "O usuário foi desativado.",
        "clientIpInvalid": "Você não tem permissão para acessar deste terminal. ",
        userNotExist: "The user does not exist. Contact the administrator. ",
        "clientIpInvalid.learnMore": "Learn more",
        "clientIpInvalid.helpUrl": "/en-us/usermanual-iam/iam_07_0003.html",
        "notAllowFpwd": "Você não tem permissão para procurar sua senha deste terminal.",
        "warning": "Aviso",
        "systemException": "O sistema está ocupado. Atualize a página e tente novamente.",
        "freqLocked": "Você excedeu o número máximo de tentativas permitido. Tente novamente mais tarde.",
        "wrongVerifyCode": "O código de verificação está incorreto ou expirou.",
        "invalidInput": "Valor inválido para o parâmetro.",
        serviceUrlInvalid: "Login failed. <a href='/'>Try again</a>. ",
        "maxSessionLimit": "O número de sessões de usuário on-line ao mesmo tempo excede o limite do sistema.",
        "multiUserInvalid": "Você acessou neste terminal. Saia e tente novamente.",
        "pageTimeout": "The operation timed out. Refresh the page and try again.",
        "accountClosed": "A conta está sendo fechada.",
        "invalidInputFourChances": "Parâmetro incorreto. Depois de mais 4 tentativas incorretas, o acesso será desabilitado por 15 minutos.",
        "invalidInputThreeChances": "Parâmetro incorreto. Depois de mais 3 tentativas incorretas, o acesso será desabilitado por 15 minutos.",
        "invalidInputTwoChances": "Parâmetro incorreto. Depois de mais 2 tentativas incorretas, o acesso será desabilitado por 15 minutos.",
        "invalidInputoneChances": "Parâmetro incorreto. Depois de mais 1 tentativa incorreta, o acesso será desabilitado por 15 minutos.",
        "loginReactivateFail": "A conta não foi ativada. O e-mail de ativação não pode ser enviado para essa conta. Tente novamente.",
        "pwdSame": "A nova senha não pode ser igual à senha antiga.",
        "initialPwdSame": "A nova senha não pode ser igual à senha inicial.",
        "historyPwdSame": "A nova senha não pode ser igual a uma senha antiga.",
        "copyrightNotice1": "© {0}, Copyright by HUAWEI CLOUD. All rights reserved. ",
        "copyrightNotice1_hk": "Copyright©{0} Huawei Services (Hong Kong) Co., Ltd.",
        "copyrightNotice2": "Todos os direitos reservados.",
        "copyrightNotice3": "Jiangsu licença ICP 09062682 número 13",
        "copyrightNotice4": "Jiangsu número B2-20130048",
        "copyrightNotice5": "Jiangsu licença de rede pública número 32011402010636",
        "legalNotice": "Aviso legal",
        "legalStatement": "Aviso legal",
        "siteTerms": "Site Terms",
        "privacyProtect": "Declaração de Privacidade",
        "privacyStrategyStatement": "Declaração de Privacidade",
        "reportAbuse": "Reportar abuso",
        "sa_nisr": "Política de Uso Aceitável",
        "sa_nisr_intl": "Política de Uso Aceitável",
        "sa_cua": "Contrato do Cliente do HUAWEI CLOUD",
        "sa_cua_intl": "Contrato do Cliente do HUAWEI CLOUD",
        "enterpriseSwitchTip": "Este modo de acesso aplica-se a usuários empresariais, ou seja, usuários criados por um administrador empresarial.",
        "personalSwitchTip": " Este modo de acesso aplica-se ao usuário empresarial, ou seja, o usuário criado durante o registro.",
        "usingOtherWaysLogin": "Usar outra conta para acessar",
        "otherWaysLogin": "Acesso de outra conta",
        "HWSdeveloper": "Aliança de Desenvolvedores da Huawei",
        "hwportal": "Site oficial da Huawei",
        "HWICTdeveloper": "Desenvolvedor de TIC da Huawei",
        "WeLink": "WeLink",
        "readAgree": "Li e concordo com ",
        "hwCloudAgreement": "Contrato do Cliente do HUAWEI CLOUD",
        "secretprotect": "Declaração de Privacidade",
        "hwCloudAgreementMobile": "Contrato do Cliente do HUAWEI CLOUD",
        "secretprotectMobile": " Declaração de Privacidade",
        "companyUserRegistration": "Registrar funcionário da empresa",
        "personalUserRegistration": "Registrar usuário",
        "companyAccountName": "Nome de usuário:",
        "userName": "Nome de usuário: ",
        "registerMail": "Endereço de e-mail:",
        "congratulationsSucceed": "Registro bem-sucedido.",
        "password": "Senha:",
        "registerMailStep3": "E-mail:",
        "passwordPlaceHolder": "Digite a senha.",
        "confirmPassword": "Confirmar senha: ",
        "confirmPasswordPlaceHolder": "Informe a senha novamente.",
        "companyName": "Empresa:",
        "contact": "Contato:",
        "phoneNum": "Número de telefone móvel: ",
        "phonePlaceHolder": "Informe o número de celular.",
        "msgCode": "Código de verificação SMS: ",
        "msgCodeTxt": "Enviar código",
        "msgPHTxt": "Código de verificação",
        "msgCodeTxtWait": "Re-enviar código ({0}s)",
        "msgCodeWrong": "O código de verificação por SMS está incorreto.",
        "region": "Região: ",
        "register.submit": "Registrar",
        "register.finish": "Concluir",
        "submit": "Avançar",
        "innerKeyWord": "As palavras-chave do sistema não são permitidas no início.",
        "accountNamePH": "Digite o nome do usuário.",
        "emailPH": "Informe seu endereço de e-mail.",
        "companyNamePH": "Informe o nome da sua empresa.",
        "mobileCompanyName": "(Opcional) Informe o nome da sua empresa.",
        "registerSuccess": "Registro bem-sucedido.",
        "pleaseCompleteInfo": "Para melhorar a segurança da conta, complete as informações da sua empresa.",
        "complete": "Complete",
        "companyInfo": "perfil da empresa",
        "rejectAndBack": "Voltar para",
        "homePage": "página inicial",
        "period": ".",
        "goTo": " Ir para",
        "myCredential": "Minhas credenciais",
        "completeUserInfo": "Completar informações pessoais.",
        "fpwd.findPasswd": "Restaurar senha",
        "fpwd.enterpriseName": "Nome da conta:",
        "fpwd.accountName": "Endereço de e-mail ou número de celular:",
        "fpwd.SMSVerifyCode": "Informe o código de verificação por SMS.",
        "fpwd.emailVerifyCode": "Informe o código de verificação do e-mail.",
        "fpwd.getCode": "Enviar código",
        "fpwd.confirmAccount": "Confirmar conta",
        "fpwd.resetPwd": "Restaurar senha",
        "fpwd.resetSuccess": "Concluir",
        "fpwd.findSuccess": "Senha reiniciada com sucesso.",
        "fpwd.newPasswd": "Nova senha:",
        "fpwd.confirmPasswd": "Confirmar senha:",
        "fpwd.enterpriseNamePH": "Informe o nome de conta.",
        "fpwd.accountNamePH": "Informe um endereço de e-mail ou número de telefone móvel.",
        "fpwd.verifyCodePH": "Informe o código.",
        "fpwd.confirmPasswdPH": "Informe a nova senha mais uma vez.",
        "fpwd.newPasswdPH": "Informe uma nova senha.",
        "fpwd.newPasswdPHApp": "Nova senha",
        "fpwd.nextStepBtn": "Avançar",
        "fpwd.backTo": "Voltar",
        "fpwd.titleDetail": "Informe as informações da conta.",
        "fpwd.titleIAMDetail": "Informe as informações do usuário do IAM.",
        "fpwd.multiUsersTip": "O número de celular está vinculado a várias contas. Selecione a conta para a qual você deseja redefinir a senha.",
        "fpwd.accountConfirm": "Verificação da conta",
        "fpwd.personalAccount": "Conta",
        "fpwd.IAMAccount": "Usuário do IAM",
        "fpwd.typePersonalTip": "Uma conta criada quando você se registrou no HUAWEI CLOUD usando um número de celular.",
        "fpwd.typeIAMTip": "Um usuário criado usando a conta do IAM.",
        "fpwd.accountOrEmailPH": "Nome da conta ou endereço de e-mail",
        "fpwd.IAMAccountPH": "Nome da conta do administrador",
        "fpwd.IAMAccountNamePH": "Nome de usuário do IAM, e-mail, número de celular",
        "fpwd.IAMAccountNamePHNew": "Nome de usuário do IAM, e-mail",
        "fpwd.identityVerification": "Verificação de identidade",
        "fpwd.identityVerificationDec": "Selecione um método de verificação de identidade.",
        "fpwd.passwordReset": "Restaurar senha",
        "fpwd.passwordResetDesc": "Defina uma nova senha.",
        "fpwd.step1.fpwdByPhone": "Use o número de celular",
        "fpwd.step1.fpwdByemail": "Use o nome da conta ou endereço de e-mail",
        "fpwd.step1.phoneAccountNamePH": "Número de celular",
        "fpwd.step2.verificationCodePH": "Informe o código de verificação.",
        "fpwd.step2.sendVerificationCode": "Enviar código",
        "fpwd.step2.unbindDesc": "Sua identidade não pode ser verificada porque nenhum endereço de e-mail ou número de celular foi vinculado à sua conta.",
        "fpwd.step2.unbindIAMDesc": "Sua identidade não pode ser verificada porque nenhum endereço de e-mail ou número de celular foi vinculado ao usuário do IAM.",
        "fpwd.step2.exceptionService": "If your mobile number or email address is unavailable, request the administrator to reset your password.",
        "fpwd.step2.sendEmailCode": "Endereço de e-mail ({0})",
        "fpwd.step2.sendMobileCode": "Número de celular ({0})",
        "fpwd.step2.unabledMethod": "Nenhum dos acima",
        "fpwd.step2.helpMsg": "Entre em contato com o atendimento ao cliente para receber ajuda.",
        "fpwd.step2.helpTel1": "China continental: +86 4000-955-988",
        "fpwd.step2.helpTel2": "Hong Kong, China: +852 800 931 122",
        "fpwd.retrieveTxt": "Re-enviar código ({0}s)",
        "fpwd.step3.showPwdTip": "Mostrar",
        "fpwd.step3.hidePwdTip": "Ocultar",
        "fpwd.goToLogin": "Acesso",
        "fpwd.successTxt": "Senha reiniciada com sucesso",
        "fpwd.loginCountdownTxt": "Você será redirecionado para a página de acesso em {0} s.",
        "domainuserAccountsLocked": "O endereço de e-mail da conta do usuário não foi ativada. Conclua a ativação clicando no link que foi enviado para seu e-mail.",
        "fpwd.sendCodeFailed": "O sistema está ocupado. Falha ao obter o código de verificação.",
        "fpwd.getCodeFail": "Você recebeu códigos de verificação 5 vezes. Tente novamente no próximo dia.",
        "wrong_sendCodeFailed": "Falha ao obter o código de verificação. Obtenha outro código de verificação.",
        "fpwd.invalidVerifyCode": "O código de verificação está incorreto. Tente novamente.",
        "fpwd.setPasswdFailed": "Falha ao definir a nova senha devido a uma exceção do servidor. Tente novamente.",
        "fpwd.ipLocked": "O endereço IP foi bloqueado.",
        "fpwd.MultipleIAMUserNameByMobile": "Use o e-mail para recuperar a senha, porque o número de celular está vinculado a vários usuários do IAM.",
        "fpwd.MultipleAccountNameByMobile": "Você precisa informar um nome de conta, porque o número de celular está vinculado a várias contas.",
        "fpwd.MultipleAccountNameByMobileError": "Não foi possível recuperar a senha usando esse número de celular, porque ele está vinculado a várias contas. Tente novamente usando o número em um computador ou com o endereço de e-mail para recuperar a senha pelo celular.",
        "fpwd.MultipleAccountsByMobileReminder": "O nome da conta precisa ser informado caso várias contas estejam usando o mesmo número de celular.",
        "fpwd.EnterCorrectEnterpriseAccount": "Informe um nome de conta que tenha sido registrado no HUAWEI CLOUD.",
        "fpwd.EnterCorrectMobile": "Informe um número de celular que tenha sido registrado no HUAWEI CLOUD.",
        "fpwd.EnterCorrectEnterpriseAccountAndMobile": "Informe um nome de conta ou número de celular que tenha sido registrado no HUAWEI CLOUD.",
        "fpwd.EnterCorrectEmail": "Informe um endereço de e-mail que tenha sido registrado no HUAWEI CLOUD.",
        "fpwd.EnterCorrectEnterpriseAccountAndEmail": "Informe um nome de conta e um endereço de e-mail corretos.",
        "fpwd.EnterCorrectEnterpriseVerificationCode": "Informe o código de verificação correto.",
        "operationTooFrequent": "As operações foram feitas frequentemente demais. Tente novamente mais tarde.",
        "fpwd.contactService": "Observação: Caso você não consiga acessar o celular ou o e-mail registrado, entre em contato com o Atendimento ao Cliente em {0} para receber ajuda., //4000-955-988, +7（495）800 1 800",
        "fpwd.contactHKService": "Observação: Caso você não tenha acesso ao e-mail registrado, entre em contato com o Atendimento ao Cliente em {0} para receber ajuda.",
        "fpwd.ErrorRegionAccount": "Insira uma conta válida da HUAWEI CLOUD.",
        "countryCodeSelect": "Selecione o código do país.",
        "bindPhone": "Número de celular:",
        "bindPhoneNum": "Número de celular:",
        "alreadyHaveAccount": "",
        "login": "Acesso",
        "loginNow": "Acesso",
        "safetyDegree": "Nível de segurança da senha:",
        "handsRegisterInfo": "Para utilizar o Serviço de Nuvem PDA da Huawei, clique ",
        "hansRegistration": "Registrar.",
        "filloutRegisterInfo": "Configurar informação de registro",
        "checkAccountInfo": "Adicionar informação sobre a conta",
        "registerSucceed": "Concluir",
        "successAccoutInfo": "Suas contas são: ",
        "descriptionInfo": "Você pode utilizar uma das contas anteriores para acessar.",
        "linkFailed": "O link expirou.",
        "linkFailedDetail": "Sua conta foi ativada ou o tempo de ativação esgotou.",
        "linkFailedHelp": "Tente ",
        "linkFailedLogin": "Acesso",
        "serverTimeout": "O tempo do servidor esgotou. Tente novamente mais tarde.",
        "mainMsg": "O e-mail de ativação foi enviado para: ",
        "secondMsg": "Você tem 24 horas para clicar no link do e-mail e completar a ativação.",
        "checkEmail": "Abrir e-mail agora",
        "didNotGetEmail": "Não recebeu o e-mail?",
        "checkSpamMail": "1. Veja a Lixeira.",
        "stillDidNotGetEmail": "2. Se ainda não recebeu o e-mail, ",
        "resendEmail": "envie o e-mail novamente.",
        "alwaysDidNotGetEmail": "3. Se você nunca conseguiu receber o e-mail, ",
        "changeMailbox": "mude o endereço de e-mail.",
        "replaceEmailTip": "O endereço de e-mail pode ser mudado uma vez a cada 24 horas. Confirme seu endereço de e-mail com cuidado.",
        "sendNewEmail": "Enviar",
        "alreadySend": "E-mail de ativação enviado.",
        "sendFailed": "Falha ao enviar o e-mail.",
        "inputEmail": "Informe seu endereço de e-mail.",
        "email": "E-mail:",
        "countToHomepage": "Redirecionando para a página de acesso em {0} segundos.",
        "registerFailed.emailRepeat": "Endereço de e-mail registrado.",
        "registerFailed.nameRepeat": "Nome de usuário registrado.",
        "registerFailed.mobileRepeat": "O número de celular foi registrado.",
        "registerFailed.nameCannotBegin": "O nome não pode começar com um dígito ou um traço-baixo (_).",
        "registerFailed.nameCannotContain": "São permitidas apenas letras, dígitos, hifens (-) e traços-baixos (_).",
        "registerSuccess.backToHomepage": "1. ",
        "registerSuccess.returnHomepage": "Página inicial",
        "registerSuccess.backToHomepageLink": "Voltar para a página inicial do HUAWEI CLOUD.",
        "registerSuccess.backToHomepageLinkP1": "Voltar para",
        "registerSuccess.backToHomepageLinkP2": "a página inicial do HUAWEI CLOUD.",
        "registerSuccess.second": "2.",
        "registerSuccess.goToBss": "Acesse ",
        "registerSuccess.goToBssFillInfo": " para completar as informações de registro. Depois, você receberá periodicamente mensagens de atividade de desconto dos serviços do HUAWEI CLOUD.",
        "registerSuccess.bssAccountInfo": "Centro do Usuário",
        "registerSuccess.redirecting": "Redirecionando...",
        "registerSuccess.redirecting.back": "Voltando para a página original em {0} segundos.",
        "registerSuccess.autoClose": "Esta página será fechada em {0} segundos.",
        "registerSuccess.browserPreventClose": "A configuração do seu navegador não permite que o sistema feche páginas automaticamente.",
        "registerSuccess.homepage": "Início",
        "registerSuccess.userCenter": "Centro do Usuário",
        "registerSuccess.consoleHome": "Console de Gerenciamento",
        "registerSuccess.helpCenter": "Ajuda",
        "resetPwd.title": "Primeiro acesso",
        "resetPwd.titleDetail": "Para melhorar a segurança da conta, insira uma nova senha.",
        "resetPwd.phone": "Número de celular verificado:",
        "resetPwd.mailbox": "Endereço de e-mail verificado:",
        "resetPwd.byPhone": "Verificar por celular",
        "resetPwd.byMailbox": "Verificar de e-mail",
        "resetPwd.smsMsgCode": "Código de verificação SMS: ",
        "resetPwd.emailMsgCode": "Código de verificação por e-mail:",
        "resetPwd.getSmsMsgCode": "Enviar código",
        "resetPwd.getEmailMsgCode": "Enviar código",
        "resetPwd.retrieveMsgCode": "Re-enviar código ({0}s)",
        "resetPwd.resetFailed": "Falha ao alterar senha.",
        "resetPwd.oldPasswd": "Senha antiga:",
        "resetPwd.newPasswd": "Nova senha:",
        "resetPwd.apiKeyTitle": "Alterar senha de API",
        "resetPwd.apiKeyDetail": "Para melhorar a segurança da conta, insira uma nova senha de API.",
        "resetPwd.apkKey": "Senha antiga de API:",
        "resetPwd.confirmNewPasswd": "Confirmar senha:",
        "resetPwd.resetPwdFailed": "A senha antiga é incorreta. Tente novamente.",
        "resetPwd.resetCount": "A senha antiga é incorreta. Se mais {0} tentativas falharem, você terá que acessar de novo.",
        "resetPwd.getCodeFail": "Erro ao obter os códigos de verificação mais de 5 vezes. Tente novamente após 15 minutos.",
        "resetPwd.InitPasswd": "Senha inicial:",
        "resetPwd.InitPasswdError": "A senha inicial está incorreta. Tente novamente.",
        "resetPwd.InitPasswdCount": "A senha inicial está incorreta. Se mais {0} tentativas falharem, você terá que acessar de novo.",
        "modifyPwdIntervalTimeLessThanMinValidTime": "Para alterar a senha, é necessário que tenha passado um período maior ou igual ao tempo de uso mínimo da senha. Clique em Cancelar para entrar no sistema.",
        "pwdModifyTitle": "Alterar senha",
        "pwdExpiredTitle": "A senha expirou",
        "pwdExpiringDesc": "A senha expirará em {0} dias. Altere-a imediatamente.",
        "pwdExpiredDesc": "Sua senha expirou. Altere-a.",
        "noRight": "Permissões insuficientes. Entre em contato com o administrador para conceder permissões.",
        "browserSupport": "O HUAWEI CLOUD funciona melhor com os seguintes navegadores",
        "browserSupport.chrome": "Chrome",
        "browserSupport.chromeVersion": "(36.0 ou posterior)",
        "browserSupport.firefox": "FireFox",
        "browserSupport.firefoxVersion": "(35.0 ou posterior)",
        "browserSupport.ie": "Internet Explorer",
        "browserSupport.ieVersion": "(9.0 ou posterior)",
        "reactivate.reactivateAccount": "Ativar conta",
        "reactivate.pleaseCheckEmail": "Sua conta não foi ativada. Por favor, entre no endereço de e-mail registrado e clique sobre o link do e-mail de registro para ativar sua conta.",
        "advertisement.txt": "Grátis as primeiras 100 vezes",
        "advertisement.buttonTxt": "Aplicar",
        "fphone.changePhoneNum": "Alterar número de celular",
        "fphone.changeSuccess": "Concluir",
        "fphone.registerEmail": "Endereço de e-mail verificado:",
        "fphone.registerEmailPH": "Informe um endereço de e-mail.",
        "fphone.emailVerifyCode": "Código de verificação por e-mail:",
        "fphone.getVerifyCodeByEmail": "Obter código de verificação por e-mail",
        "fphone.emailVerifyCodePH": "Informe o código.",
        "fphone.newPhoneNum": "Novo número de celular:",
        "fphone.newPhoneNumPH": "Informe um novo número de celular.",
        "fphone.smsVerifyCode": "Código de verificação por SMS:",
        "fphone.getVerifyCodeBySms": "Obter código de verificação por SMS",
        "fphone.smsVerifyCodePH": "Informe o código.",
        "fphone.changePhoneSuccess": "O número de celular foi alterado com sucesso.",
        "fphone.newPhoneNumInfo": "Novo número de celular:",
        "fphone.phoneRepeat": "O número de celular já existe.",
        "fphone.exceedMaxAccounts": "O número de contas vinculadas a esse número de celular atingiu o limite máximo permitido (6).",
        "mobileNumber": "celular:",
        "fphone.changeMobile": "Alterar número de celular",
        "sendSmsIntervalErr": "O número de tentativa para obter códigos de verificação excedeu o limite máximo. Tente novamente após 1 minuto.",
        "cookie.chromeDesc": "Selecione Configurações. Na página Configurações, clique em Mostrar configurações avançadas e selecione Configurações de conteúdo em Privacidade. Na caixa de diálogo Configurações de conteúdo, desmarque Bloquear cookie de terceiros e dados do site, selecione Permitir dados locais (recomendado) e clique em Concluir. Depois, reinicie o navegador e acesse novamente.",
        "cookie.firefoxDesc": "Clique em Opções e selecione Privacidade. Na página Privacidade, selecione Configurações personalizadas de histórico, desmarque Sempre usar o modo de navegação com privacidade, selecione Aceitar cookies de sites e clique em OK. Depois, reinicie o navegador e acesse novamente.",
        "cookie.ieDesc": "Selecione Ferramentas > Opções de Internet. Na caixa de diálogo Opções de Internet, clique na guia Privacidade. Na guia Privacidade, ajuste Bloquear todos os cookies para a opção mais baixa e clique em Salvar. Depois, reinicie o navegador e acesse novamente.",
        "cookie.chromeName": "Google Chrome:",
        "cookie.firefoxName": "Mozilla Firefox:",
        "cookie.ieName": "Internet Explorer:",
        "cookie.title": "Como eu ativo cookies no meu navegador?",
        "cookie.loginTip": "Acesse depois que os cookies estiverem ativados.",
        "cookie.startCookie": "Ativar cookies?",
        "verifyCode.intervalError": "Houve solicitações demais de códigos de verificação. Tente novamente após 1 minuto.",
        "verifyCode.invalid": "O código de verificação expirou. Clique em Enviar código para receber outro.",
        "verifyCode.error": "O código de verificação está incorreto. Tente novamente.",
        "verifyCode.locked": "Você excedeu o número máximo permitido de solicitações de código de verificação. Tente novamente no próximo dia.",
        "verifyCode.locked.custom": "Você excedeu o número máximo permitido de solicitações de código de verificação. Tente novamente após {0} minutos ou entre em contato com o atendimento ao cliente pelo telefone 4000-955-988.",
        "verifyCode.sendFailed": "Houve uma falha no envio do código de verificação. Obtenha outro.",
        "verifyCode.remainderCount": "Você tem {0} tentativas de verificação restando. Caso as tentativas restantes não sejam bem-sucedidas, um novo código de verificação só poderá ser gerado após um período específico.",
        "verifyCode.cantAcquire": "A função de solicitação de código de verificação foi bloqueada. Informe o último código de verificação obtido.",
        "verifyCode.emailInvalidAndSMSError": "O código de verificação por SMS está incorreto. Tente novamente com um código de verificação por e-mail válido.",
        "verifyCode.email.invalid": "O código de verificação por e-mail expirou. Obtenha outro.",
        "verifyCode.email.error": "O código de verificação por e-mail está incorreto. Tente novamente.",
        "verifyCode.sms.invalid": "O código de verificação por SMS expirou. Obtenha outro.",
        "verifyCode.sms.error": "O código de verificação por SMS está incorreto. Tente novamente.",
        "verifyCode.usernameRepeat": "O nome de usuário já existe. Informe outro.",
        "verifyCode.maxmiumSubUserNum": "O número de usuários atingiu o limite máximo.",
        "verifyCode.emailExist": "O endereço de e-mail já existe. Informe outro.",
        "loginVerification": "Verificação de acesso",
        "loginVerification.tips": "If you do not want the custom information to be displayed during login, contact the administrator.",
        "titles.loginVerification": "Verificação de acesso à nuvem",
        "loginVerification.presetLoginInfo": "Informações de acesso predefinidas",
        "loginVerification.warningInfo": "Se as informações exibidas são inconsistentes com as suas informações de acesso predefinidas, cancele o acesso.",
        "loginVerification.checkBySMS": "Verificação por SMS",
        "loginVerification.SMSHasSentTo": "(O código de verificação por SMS foi enviado para o seu celular)",
        "loginVerification.pleaseClickAgain": "(Se você não o receber em 60s, clique em Enviar o código novamente.)",
        "loginVerification.userLoginInfo": "Informações de acesso",
        "loginVerification.lastSuccessTime": "Último acesso bem-sucedido",
        "loginVerification.lastFailedTime": "Último acesso com falha",
        "loginVerification.failedTimes": "Tentativas consecutivas de acesso com falha",
        "loginVerification.lockInfo": "Após {0} tentativas incorretas consecutivas, o usuário atual ficará bloqueado durante {1} minutos.",
        "loginVerification.MFATitle": "Autenticação de acesso por MFA virtual",
        "loginVerification.MFAContext": "Informe o código de verificação de 6 dígitos gerado no aplicativo Authenticator., ",
        "loginVerification.MFAHelp": "Descubra como conseguir o código de autenticação.",
        "loginVerification.MFALabel": "Código de autenticação MFA",
        "loginVerification.MFANotUseTip": "O dispositivo de MFA virtual está indisponível?",
        "loginVerification.MFANotUseMessage1": "Entre em contato com o administrador do HUAWEI CLOUD da empresa para redefinir o dispositivo de MFA virtual.",
        "loginVerification.MFANotUseMessage2": "Entre em contato com o atendimento ao cliente do HUAWEI CLOUD.",
        "loginVerification.resetMFAHelpUrl": "<a href='{0}' target='_blank' rel='noopener noreferrer'>Learn how</a> to unbind or remove a virtual MFA device.",
        "loginVerification.rememberMFALabel": "Remember me for 7 days", 
        "loginVerification.rememberMFALabel.disabledTip": "Limited to 5 IAM users per browser. ",
        "loginVerification.emailCheckTitle": "Autenticação de acesso por e-mail",
        "loginVerification.emailCheckContent": "(Um código de autenticação foi enviado para {0}.)",
        "loginVerification.emailCodeLabel": "Código de verificação por e-mail",
        "loginVerification.emailCodeTxt": "Enviar código",
        "loginVerification.verificationType": "Método de autenticação",
        "loginVerification.verificationTypeForPhone": "绑定手机号与验证方式",
        "loginVerification.verificationTypeForEmail": "绑定邮件地址与验证方式",
        "loginVerification.bindPhone": "Número de celular",
        "loginVerification.bindPhoneTips": "O administrador ativou a autenticação por celular. Por favor, informe um número de celular.",
        "loginVerification.bindPhonePH": "Informe um número de celular.",
        "loginVerification.bindEmail": "Endereço de e-mail",
        "loginVerification.bindEmailTips": "O administrador ativou a autenticação por e-mail. Por favor, informe um endereço de e-mail.",
        "loginVerification.bindEmailPH": "Informe um endereço de e-mail.",
        "loginVerification.verifyCode": "Código de verificação",
        "loginVerification.verifyCodeBtnTxt": "Enviar código",
        "loginVerification.verifyCodePH": "Código de 6 dígitos",
        "loginVerification.verifyCodeEmailPH": "Código de 6 dígitos",
        "loginVerification.sendCodeTxt": "O código de verificação foi enviado. Para garantir a segurança da conta, não o compartilhe com ninguém.",
        "loginVerification.sendCodeFailed": "Houve uma falha ao enviar o código de verificação porque o sistema está ocupado.",
        "loginVerification.validEmailOrPhone": "Informe um endereço de e-mail válido ou um número de celular.",
        "loginVerification.retrieveTxt": "Re-enviar código ({0}s)",
        "loginVerification.otherAccount": "Usar outra conta",
        "loginVerification.goOnLogin": "OK",
        "loginVerification.title": "Vincular dispositivo de MFA virtual",
        "loginVerification.firstStep": "Etapa 1: Fazer o download e instalar o aplicativo Authenticator no seu celular.",
        "loginVerification.firstStepIntroduction": "The authenticator app will prompt you to add your account.",
        "loginVerification.secondStep": "Etapa 2: Configurar o aplicativo Authenticator.",
        "loginVerification.secondStepIntroduction": "Abra o aplicativo Authenticator no seu smartphone. Escaneie o código QR ou informe a chave secreta a seguir no aplicativo para obter códigos de autenticação de seis dígitos.",
        "loginVerification.username": "Nome de usuário",
        "loginVerification.domainname": "Nome da conta",
        "loginVerification.secretKey": "Chave secreta",
        "loginVerification.thirdStep": "Etapa 3: Informe os códigos de verificação.",
        "loginVerification.thirdStepIntroduction": "Use o Authenticator para gerar dois códigos de autenticação consecutivos e informe-os aqui.",
        "loginVerification.firstRegCode": "Código de autenticação 1",
        "loginVerification.secondRegCode": "Código de autenticação 2",
        "loginVerification.submitText": "OK",
        "loginVerification.bindMFASucceed": "Dispositivo de MFA virtual vinculado com sucesso.",
        "loginVerification.mfaCodeError": "Código de verificação MFA incorreto. Informe outro código.",
        "loginVerification.mfaCodeLocked": "Você tentou muitas vezes em um curto espaço de tempo. Tente novamente depois de 5 minutos.",

        "bindAccount.title": "Vincular conta do HUAWEI CLOUD",
        "bindAccount.submit": "Registrar e vincular",
        "registerGiftSuffixMobile": "Itens populares",
        "bindAccount.remindCompleteInfo": "Informe os dados a seguir para registrar e vincular uma conta do HUAWEI CLOUD.",
        "bindAccount.bindSuccess": " Registro concluído com sucesso. Você vinculou a conta do HUAWEI CLOUD.",
        "bindAccount.HWSAccount": "Sua conta do HUAWEI CLOUD:",
        "bindAccount.timeRemind": "Após {0} segundos",
        "bindAccount.redirectPage": "Voltar para a página original",
        "validCountryCode": "Selecione um código de país válido.",
        "registerGift": "Caso o registro tenha sido bem-sucedido, você pode usar cupons de dinheiro.",
        "registerGiftAddress": "Usar cupons de dinheiro",
        "registerSuccess.goToGift": "Ir para ",
        "registerSuccess.goToGiftFillInfo": " para usar cupons especiais de dinheiro para novos usuários.",
        "usercompanyAccount": "Estas são as informações da sua conta:",
        "welcomeLogin.titleDetail": "Para a segurança da sua conta, defina uma senha.",
        "welcomeEmail.title": "E-mail de boas-vindas",
        "welcomeEmail.linkTimeout": "Desculpe, sua conexão não é válida porque o tempo esgotou.",
        "welcomeEmail.linkExpired": "Desculpe, sua conexão não está disponível.",
        "welcomeEmail.resendEmail": "Clique aqui para enviar um novo e-mail de boas-vindas.",
        "welcomeEmail.contactAdm": "Entre em contato com o administrador para enviar um novo e-mail de boas-vindas.",
        "welcomeEmail.alreadySend": "Foi enviado um e-mail de boas-vindas.",
        "titles.setPassword": "Senha definida do HUAWEI CLOUD",
        "titles.welcomeEmail": "E-mail de boas-vindas do HUAWEI CLOUD",
        "welcomeEmail.setPassword": "Definir senha",
        "dateFormate": "M/d/a HH:mm:ss",
        "sessionExpired": "Sua sessão expirou. Acesse novamente.",
        "m.userNamePlaceHolder": "Nome de usuário/E-mail/Número de celular",
        "m.HongKongUserNamePlaceHolder": "Nome de usuário/E-mail",
        "m.accountNamePlaceHolder": "Nome de usuário/E-mail",
        "m.HongKongAccountNamePlaceHolder": "Nome de usuário/E-mail",
        "m.verifyCodePlaceHolder": "Verifique o código",
        "inValidCountryCode": "Selecione um código de país válido.",
        "mobile.CountryCode": "+86 (China)",
        "authenticationInfo": "Algumas funções estão indisponíveis para usuários sem autenticação com nome verdadeiro.",
        "authenticationForwardInfo": "Complete a autenticação com nome verdadeiro para ter uma experiência melhor de serviço.",
        "authenticationForward": "autenticação com nome verdadeiro",
        "registerSuccess.goToAuthentication": "Você pode completar",
        "registerSuccess.authenticationInfo": "para ter uma avaliação grátis de 6 meses do pacote.",
        "fpwd.findByEmail": "Redefinir senha usando o e-mail",
        "fpwd.findByPhone": "Redefinir senha usando o número de celular",
        "fpwd.accountNameByEmail": "E-mail registrado:",
        "fpwd.accountNameByPhone": "Número de celular registrado:",
        "fpwd.phoneAccountNamePH": "Informe um número de celular.",
        "eChannelName": "Parceiro da Huawei Enterprise",
        "uniportalName": "Conta da Huawei",
        "moreLink": "Mais",
        "registerSuccess.authenticationForward": "Conclua a autenticação com nome verdadeiro",
        "homepageLink": "Início",
        "helpCenter": "Documentação",
        "cloudCommunity": "Comunidade da nuvem",
        "registerSuccess.goToUserZone": "Ir para ",
        "registerSuccess.userZoneLink": "Nova zona de usuários",
        "registerSuccess.userZoneInfo": " para ter um desconto especial de 50% do pacote.",
        "register.accountPlaceHolder": "Nome da conta",
        "register.passwordPlaceHolder": "Senha",
        "register.confirmPasswordPlaceHolder": "Confirmar senha",
        "register.phonePlaceHolder": "Número de celular",
        "register.msgCodePlaceHolder": "Código de verificação",
        "register.accountNameLength": "Informe de 5 a 32 caracteres.",
        "register.bindACccountPlaceHolder": "Nome de domínio/Endereço de e-mail/Número de celular",
        "remindBindEmail.title": "Endereço de e-mail vinculado",
        "remindBindEmail.remindMsg": "Sua conta ainda não tem um endereço de e-mail vinculado. Vincular endereço de e-mail a:",
        "remindBindEmail.remindInfo1": "● Receber notificações quando os recursos da nuvem forem fornecidos, excluídos ou estiverem prestes a expirar.",
        "remindBindEmail.remindInfo2": "● Verificar sua identidade quando estiver prestes a realizar operações importantes, como alteração de número de celular, redefinição de senhas e exclusão de ECSs.",
        "remindBindEmail.bind": "Vincular agora",
        "remindBindEmail.nextBind": "Vincular mais tarde",
        "remindBindEmail.remind": "Informações",
        "remindBindEmail.remindHideInfo": "Vincule um endereço de e-mail em uma nova página.",
        "remindBindEmail.remindHideFailde": "Se a vinculação não funcionar, tente novamente para ",
        "remindBindEmail.remindHideFailde2": "vincular outro endereço de e-mail.",
        "remindBindEmail.remindHideSuccess": "Vinculação concluída",
        "notify.openPage": "Please wait...",
        "notify.closeSecondBefore": "Operation Successful.",
        "notify.closePage": "Operation successful. Please close the page",
        "registerFailed.accountNameRepeat": "O nome da conta foi registrado.",
        "register.bindAccountPlaceHolder": "Nome da conta/Endereço de e-mail/Número de celular",
        "privacyPolicyUpdate": "Atualização da Declaração de Privacidade",
        "privacyTipPre": "Dear customer, we have updated the HUAWEI CLOUD Privacy Statement. We understand the importance of your privacy and are fully committed to protecting it. Please read the updated",
        "privacyTipSuf": "carefully to learn how we protect your personal data.",
        "agreementBtnTxt": "Agree",
        "privacyAgreementNotAcceptedError": "Por favor, leia e concorde com a Declaração de Privacidade do HUAWEI CLOUD primeiro.",

        "OIDC.errorDefault": "System error. Please contact the administrator.",
        "OIDC.errorO001": "System error. Please try again.",
        "OIDC.errorO002": "Invalid domain ID.",
        "OIDC.errorO003": "Invalid identity provider ID.",
        "OIDC.errorO004": "Invalid service URL.",
        "OIDC.errorO005": "Cannot find the OpenID Connect configuration.",
        "OIDC.errorO006": "Invaid OpenID configuration.",
        "OIDC.errorO007": "Invalid ID Token.",
        "OIDC.errorO008": "The State parameter is invalid.",
        "OIDC.errorO009": "Invalid JWT.",
        "OIDC.errorO010": "Acl check failed.",
        "OIDC.errorO011": "Failed to obtain the IAM token based on the mapping rules. Check the mapping rules or contact the administrator.",
        "OIDC.errorO012": "No reachable project to log in.",
        "OIDC.errorO013": "Too many requests. Please try again later.",
        "OIDC.errorO014": "Cannot access the console in the [program] access mode.",
        "OIDC.errorO015": "Invalid error.",
        "console_term_500Error_label":"The system is busy. Please try again later.",
        "console_term_404Error_label":"Sorry! Failed to find the page.",
        "console_term_401Error_label":"Sorry! The page has expired.",
        "titles.loginReminder": "HUAWEI CLOUD – Login",
        
        //扫码登录需求相关词条
        "QRLogin.title1": "QR Login",
        "QRLogin.title2": "Log in to Huawei Cloud",
        "QRLogin.countDownTipPre1": "Please use the ",
        "QRLogin.countDownTipPre2": "HUAWEI CLOUD APP",
        "QRLogin.countDownTipPre3": " to scan the QR code to log in ",
        "QRLogin.remainingTime": "{0} seconds",
        "QRLogin.countDownTipSuffix": "QR code expires after ",
        "QRLogin.QRCodeInvalid": "QR code has expired",
        "QRLogin.refresh": "refresh",
        "QRLogin.scanSuc": "Scan Successfully",
        "QRLogin.scanSucTip": "Please follow the prompts to confirm login on your phone",
        "QRLogin.loginFail": "Login Failed",
        "QRLogin.loginFailTipPre": "Please click ",
        "QRLogin.loginFailTipSuffix": " and re-scan the QR code to log in",
        "QRLogin.downloadApp": "Download HUAWEI CLOUD App",
        "QRLogin.comma":", ",
        "QRLogin.loginReminder": "Login Reminder",
        "QRLogin.accountLogin": "Password Login",

        //统一ID相关
        "hwId.cookieMsg": "Utilizamos cookies para melhorar o nosso site e a sua experiência de navegação. Ao continuar navegando em nosso site, você aceita a nossa política de cookies.",
        "hwId.hwAccount": "HUAWEI ID",
        "hwId.privacyContent": "Durante o acesso, você concorda em fornecer à HUAWEI CLOUD as suas informações da conta e da rede para nos ajudar a oferecer uma experiência melhor. ",
        "hwId.hwportal": "Conta do site oficial da Huawei",
        "hwId.eChannel": "Huawei Enterprise Partner",
        "hwId.casLogin.systemError": "Erro",
        "hwId.casLogin.systemErrorDesc": "Ocorreu um erro de sistema. Atualize a página ou entre em contato com o atendimento ao cliente por meio do seguinte endereço de e-mail: clientes@huaweicloud.com.",
        "hwId.casLogin.accountError": "Erro",
        "hwId.casLogin.accountErrorDesc": "Sua conta não pode ser usada para acessar a HUAWEI CLOUD. Realize o acesso com outra conta.",
        "hwId.casLogin.accountErrorLink": "Saiba mais",
        "hwId.casLogin.accountErrorUrl": "/en-us/iam_faq/iam_01_0006.html",
        "hwId.casLogin.loginError": "Erro",
        "hwId.casLogin.loginErrorDesc": "Você não pode usar sua conta para fazer login no HUAWEI CLOUD neste modo. Clique em HUAWEI ID Login e faça login.",
        "hwId.casLogin.accountExternalErrorDesc": "Sua conta está registrada na Europa ou Rússia e, portanto, não pode ser usada para acessar a HUAWEI CLOUD. Realize o acesso usando uma conta registrada em outro país ou região.",
        "hwId.casLogin.accountExternalErrorLink": "Saiba mais sobre a inviabilidade do acesso.",
        "hwId.casLogin.accountTurkeyErrorLink": "Your current account is registered in [Turkey]. HUAWEI CLOUD does not support accounts in Turkey. Please <a href='{0}' target='_blank' rel='noopener noreferrer'>register for a HUAWEI CLOUD account</a> immediately, or log in with accounts in other region.",
        "hwId.casLogin.inactivatedError": "Conta não ativada",
        "hwId.casLogin.inactivatedErrorDesc": "Sua conta não foi ativada. Ative sua conta dentro de 24 horas clicando no link de ativação que foi enviado para o endereço de e-mail vinculado a ela.",
        "hwId.casLogin.inactivatedErrorDesc.noEmail": "Sua conta não pode ser usada para acessar os serviços da HUAWEI CLOUD, porque ela não foi ativada e não está vinculada a um endereço de e-mail. Realize o acesso com outra conta.",
        "hwId.casLogin.inactivatedHwidError": "Serviços da HUAWEI CLOUD não ativados",
        "hwId.casLogin.inactivatedHwidErrorDesc": "Os serviços da HUAWEI CLOUD não foram ativados para sua conta. Ative os serviços da HUAWEI CLOUD para sua conta dentro de 24 horas clicando no link de ativação que foi enviado para o endereço de e-mail vinculado a ela.",
        "hwId.casLogin.inactivatedHwidErrorDesc.noEmail": "Você não pode usar os serviços da HUAWEI CLOUD, porque eles não foram habilitados para sua conta, e sua conta não está vinculada a um endereço de e-mail. Realize o acesso com outra conta.",
        "hwId.casLogin.accessErrorDesc" : "A HUAWEI CLOUD não pôde obter informações da sua conta. Realize o acesso usando outra conta.",
        "hwId.refresh" : "Atualizar",
        "hwId.cookies": "Cookies",
        "hwId.otherAccount" : "Usar outra conta :",
        "hwId.otherAccount.h5" : "Usar outra conta",
        "hwId.hwIdLogin": "Huawei Account Login",
        "hwId.accountPlaceHolder" : "Nome do locatário ou nome da conta da HUAWEI CLOUD",

        //统一ID升级提示页面
        "hwId.upgradeTitle": "Upgrade to HUAWEI ID and Get Access to All Huawei Services",
        'hwId.upgradeDesc': 'You are logged in with a HUAWEI CLOUD account, which is just for HUAWEI CLOUD services. Upgrade your account to a HUAWEI ID to access the full range of Huawei services, including HUAWEI Developers, HUAWEI devices (such as HUAWEI Phones), Huawei Mobile Services (such as HUAWEI Mobile Cloud and HUAWEI Video). After upgrading, you\'ll be able to use your HUAWEI ID for all your HUAWEI CLOUD resources as well. ',
        'hwId.upgradeDescLink': 'Learn more',
        'hwId.upgradeAgreements.pre': 'I understand that HUAWEI ID collects my account name, mobile number, email address, registration country/region, and login credentials, and I have read and agree to',
        "hwId.upgradeAgreements.userAgreement" : "Contrato de Usuário da HUAWEI ID",
        "hwId.upgradeAgreements.and" : " e a ",
        "hwId.upgradeAgreements.privacyPolicy" : "Declaração sobre o HUAWEI ID e a Privacidade",
        "hwId.upgradeAgreements.period" : ".",
        "hwId.upgradeBtnTxt" : "Atualizar agora",
        "hwId.upgradeCancelBtnTxt" : "Atualizar depois",
        "hwId.upgradePageTitle" : "Atualização da conta - HUAWEI CLOUD",
        "hwId.upgradeGoBack" : "Atualizar conta",
        "hwId.upgradeErrorTitle" : "Erro no carregamento",
        "hwId.upgradeErrorDesc" : "Erro de serviço. Entre em contato com o atendimento ao cliente.",
        "hwId.upgradeErrorBtn": "OK",
        "hwId.forgetPwd": "Esqueceu a senha",
        "hwId.hwCloudAccount": "HUAWEI CLOUD Account",
        "hwId.hwCloudAccountLogin": "Acesso de conta",

        //统一ID找回密码页面改造
        "fpwd.accountFpwdTitle": "Reset HUAWEI CLOUD Account Password",
        "fpwd.iamFpwdTitle": "Reset IAM User Password",
        "fpwd.goAccountFpwd": "Reset HUAWEI CLOUD Account Password",
        "fpwd.goIAMFpwd": "Reset IAM User Password",
        "fpwd.step2.accountHelpMsg": "If you cannot perform verification using your mobile phone and email account currently, please call +86 4000 955 988 (Chinese mainland) or +852 800 931 122 (Hong Kong, China). If you have already retrieved your password, log in now.",
        "fpwd.step2.switchPhoneVerify": "Mobile Number Verification",
        "fpwd.step2.switchEmailVerify": "Email Address Verification",
        "fpwd.pwdValidateRule": "Password requirements:",
        "fpwd.pwdSafetyDegree": "Password strength:",
        "fpwd.selectUserTitle": "Select Account Name",
        "fpwd.step1.fpwdByEmail": "Account Name/Email Address Verification",
        "fpwd.step1.fpwdByPhone": "Mobile Number Verification",
        "fpwd.step1.phoneAccountNamePH": "Mobile number",
        "fpwd.verifyCodePlaceHolder": "CAPTCHA code",
        "fpwd.accountOrEmailPH": "Account name or email address",
        "fpwd.IAMAccountPH": "Nome da conta do administrador",
        "fpwd.IAMAccountNamePHNew": "IAM user name or email address",
        "fpwd.step2.sendVerificationCode": "Send Code",
        "fpwd.confirmPasswdPH": "Enter the new password again.",
        "fpwd.accountOrEmailPH.h5": "Account name or email address",
        "fpwd.step1.phoneAccountNamePH.h5": "Mobile number",
        "fpwd.IAMAccountPH.h5": "Nome da conta do administrador",
        "fpwd.IAMAccountNamePHNew.h5": "IAM user name or email address",
        "fpwd.verifyCodePlaceHolder.h5": "CAPTCHA code",
        "fpwd.newPasswdPH.h5": "Enter a new password.",
        "fpwd.confirmPasswdPH.h5": "Enter the new password again.",
        "fpwd.iamFpwdAccountError": "Please enter the correct IAM user name",

        // 快捷登录
        "quickLogin.title": "Quick Login",
        "quickLogin.loginTip": "Log in through SMS or email verification.",
        "quickLogin.accountInputPH": "Mobile number, email address, or account name",
        "quickLogin.smsCodePH": "Verification code",
        "quickLogin.emailCodePH": "Verification code",
        "quickLogin.codeBtn": "	Send Code",
        "quickLogin.codeCountdown": "Resend Code ({0}s)",
        "quickLogin.mobileLogin": "Mobile Number Verification",
        "quickLogin.emailLogin": "Email Address Verification",
        "quickLogin.selectUsersTitle": "Select Account",
        "quickLogin.selectUsersTitle.h5": "Select Account",
        "quickLogin.notAllowed": "This account does not support quick login. Use another account.",
        "quickLogin.smsCodeMsg": "Send a verification code to the mobile number {0}.",
        "quickLogin.emailCodeMsg": "Send a verification code to the email address {0}.",
        "quickLogin.noMobile": "This account is not associated with a mobile number. Log in using an email address.",
        "quickLogin.noEmail": "This account is not associated with an email address. Log in using a mobile number.",
        "quickLogin.qucikLoginTip": "This account has been upgraded to a HUAWEI ID. Log in through the HUAWEI ID login page.",
        "quickLogin.notActivate": "This account is not activated, quick login is not allowed",
        "quickLogin.register": "Free Registration",

        "ssologin.title": "Selecionar provedor de identidade",
        "ssologin.btnTxt": "Acessar",
        
        "idpLogin.loginLink": "Usuário federado",
        "idpLogin.title": "Acesso de usuário federado",
        "idpLogin.h5SelectTip": "Selecionar provedor de identidade",
        "idpLogin.accountPh": "Nome da conta ou do locatário da HUAWEI CLOUD",
        "idpLogin.listPh": "Provedor de identidade",
        "idpLogin.goLogin": "Acessar",
        "idpLogin.goAccountLogin": "Conta da HUAWEI CLOUD",
        "idpLogin.noIdps": "Esta conta não está vinculada a qualquer provedor de identidade. Insira outro nome de conta ou de locatário.",
        "idpLogin.domainNotExist": "Esta conta não existe. Insira outro nome de conta ou de locatário.",

        'selfManage.alertTip': 'The administrator has disabled Information Self-Management. If you need to modify your information, contact the administrator.',
    };
    function i18n(key) {
        return i18n.framework[key];
    };
    i18n.framework = framework;
    return i18n;
});



// WEBPACK FOOTER //
// ./public/hws/i18n/pt-br/resource.js